import { trim, escapeRegExp, get } from 'lodash';

interface Mention {
    id: string;
    display: string;
}

// extract email ids and return an array of them for new mentions
export const getMentions = (str, mentions: Mention[] = []) => {
    if (!str) {
        return [];
    }

    return mentions.reduce((acc: string[], val) => {
        const regex = new RegExp(
            `@\\[${escapeRegExp(val.display)}\\]\\(${escapeRegExp(val.id)}\\)`,
            'gi'
        );
        const matches = str.match(regex);

        if (matches) {
            acc.push(val.display);
        }
        return acc;
    }, []);
};

// remove mentions meta data and replace with its display
export const removeMentions = (str: string, mentions: Mention[] = []) => {
    if (!str) {
        return '';
    }
    return mentions.reduce((acc, val) => {
        const regex = new RegExp(
            `@\\[${escapeRegExp(val.display)}\\]\\(${escapeRegExp(val.id)}\\)`,
            'gi'
        );
        const matches = str.match(regex);
        if (matches) {
            const uniqueMatch = new Set(matches);
            let updatedAcc = acc;
            uniqueMatch.forEach(match => {
                const regex = new RegExp(val.display, 'i');
                const cleanMention = get(match.match(regex),0);
                updatedAcc = updatedAcc.replaceAll(match, `@${cleanMention}`);
            });
            return updatedAcc;
        }
        return acc;
    }, trim(str));
};
